module.exports = __webpack_public_path__ + "img/image 15.8777b281.png";